import ScrollSpy from '../lib/classes/ScrollSpy';

/*
  v-scrollspy="{ value }"

  value: {
    linkSelector: 'a',
    scrollElement: 'body', // 'body' | element | selector
    activeTarget: 'parent', // 'parent' | 'self' | selector
    activeClass: 'active',
    offset: 24,
    onActivate: null,
  }
 */
export default {
  inserted(el, binding, vnode) {
    const onActivate = item => {
      vnode.context.$emit('scrollspy-activate', item);
      if (binding.value && typeof binding.value.onActivate === 'function') {
        binding.value.onActivate(item);
      }
    };

    const options = Object.assign({}, binding.value, { onActivate });
    const scrollspy = new ScrollSpy(el, options);

    vnode.context.$on('scrollspy-refresh', () => scrollspy.refresh());
  },
};
